import { useState } from "react";
import { Box, Tabs, Tab, Grid, Link } from "@mui/material";
import ManualRechargeUI from "./ManualRechargeUI";
import TransactionHistoryUI from "./TransactionHistoryUI";
import { useNavigate, useNavigationType } from "react-router-dom";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { getHospitalBranchById } from "../../../services/hospitalServices";
import ArrowBackIos from "@mui/icons-material/ArrowBackIos";

function ManualRechargePage() {
  const [tab, setTab] = useState(0);
  const navigate = useNavigate();

  const [responseData, setResponseData] = useState([]);
  
  const ID = window.location.href
    .split("creditLimit/creditLimit/managecredits/")[1]

  // console.log("ID", ID);

  const getData = async () => {
    // let response = await getJobJobsByIdService(ID);
    let response = await getHospitalBranchById(ID);
    // console.log("426--->", response);

    setResponseData(response[0]);

    return response[0];
  };

  console.log("responseData", responseData);

    const {
      register,
      handleSubmit,
      control,
      setValue,
      reset,
      getValues,
      formState: { errors },
    } = useForm({
      mode: "onSubmit",
      defaultValues: async () => await getData(),
    });

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <Box
      sx={{
        pl: "260px", // sidebar width
        pr: 3,
        pt: 3,
        width: "100%",
      }}
    >
      <div style={{ display: "flex", width: "70px" }}>
        <Link onClick={handleBack}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              marginBottom: "10px",
            }}
          >
            <ArrowBackIos fontSize="small" />
            back
          </div>
        </Link>
      </div>
      <Box sx={{ fontSize: "28px", fontWeight: 600, mb: 2 }}>
        Manual Recharge - {responseData?.jobLocation?.hospitalName}
      </Box>

      {/* ----------- Tabs ----------- */}
      <Tabs
        value={tab}
        onChange={(e, v) => setTab(v)}
        sx={{
          mb: 3,
          "& .MuiTab-root": {
            textTransform: "none",
            fontSize: "16px",
            fontWeight: 600,
            minWidth: 180,
          },
          "& .Mui-selected": {
            color: "#0d47a1",
          },
          "& .MuiTabs-indicator": {
            backgroundColor: "#0d47a1",
            height: "3px",
          },
        }}
      >
        <Tab label="Manage Credits" />
        <Tab label="Transaction History" />
      </Tabs>

      {/* ----------- Tab Panels ----------- */}

      {tab === 0 && (
        <Box>
          {/* YOUR FULL MANAGE CREDIT UI */}
          <ManualRechargeUI responseData={responseData} onRefresh={getData} setTab={setTab} />
        </Box>
      )}

      {tab === 1 && (
        <Box>
          {/* YOUR FULL TRANSACTION HISTORY UI */}
          <TransactionHistoryUI responseData={responseData} />
        </Box>
      )}
    </Box>
  );
}

export default ManualRechargePage;
